import React, { Fragment } from "react";

class MyErrorBoundary extends React.Component {
  state = {
    errorMessage: "",
  };

  static getDerivedStateFromError(error) {
    return { errorMessage: error.toString() };
  }

  componentDidCatch(error, info) {
    this.logErrorToServices(error.toString(), info.componentStack);
  }

  // A fake logging service.
  logErrorToServices = console.log;

  render() {
    if (this.state.errorMessage) {
      return (
        <Fragment>
          <div className="page-wrapper">
            <div className="error-wrapper">
              <div className="container">
                <img
                  className="img-100"
                  src="/assets/images/sad.png"
                  alt=""
                />
                <div className="error-heading">
                  <h2 className="headline font-primary">500</h2>
                </div>
                <div className="col-md-8 offset-md-2">
                  <p className="sub-content">
                    The page you are attempting to reach is currently not
                    available. This may be because the page does not exist or
                    has been moved.
                  </p>
                </div>
                <div>
                  <a className="btn btn-primary-gradien btn-lg" href="/">
                    BACK TO HOME PAGE
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
      //   return <p>{this.state.errorMessage}</p>;
    }
    return this.props.children;
  }
}

export default MyErrorBoundary;
